<template>
  <v-container class="mx-auto mt-15">
    <v-row>
      <v-col lg="12">
        <div class="cerceve">
          <div class="deneme">
            <v-row>
              <v-col cols="4">
                <ul>
                  <li v-for="item in data.slice(0, 4)" :key="item.keyWord">
                    <a :href="`/sigorta-sozlugu/${item.screenId}`">{{
                      item.keyWord
                    }}</a>
                  </li>
                </ul>
              </v-col>
              <v-col cols="4">
                <ul>
                  <li v-for="item in data.slice(4, 8)" :key="item.keyWord">
                    <a :href="`/sigorta-sozlugu/${item.screenId}`">{{
                      item.keyWord
                    }}</a>
                  </li>
                </ul>
              </v-col>
            </v-row>
          </div>
          <div class="kutuBir">
            <p><v-icon large color="white">fas fa-search-plus</v-icon></p>
            <p>En Çok Merak Edilenler?</p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      BASE_URL: "",
      data: []
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      // get base url
      await axios
        .get("config.json")
        .then(response => {
          this.BASE_URL = response.data.BASE_URL
          console.log("BASE_URL getirildi:", this.BASE_URL)
        })
        .catch(error => {
          console.log(error)
        })

      // get data
      await axios
        .get(this.BASE_URL + "/adm/dictionary/star")
        .then(response => {
          this.data = response.data
          console.log("En çok merak edilenler verisi geldi:", this.data)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
